import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {AppearingContainer} from "./AppearingContainer";
import {TranslatableText} from "./TranslatableText";

// Constructor
export class GameTitle extends AppearingContainer {

  constructor(x, y, appearingScreenPercent, game) {
    super(appearingScreenPercent, game);

    this.game = game;
    this.position.set(x, y);
    this.eventMode = "none";

    this.textStyle = new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 40,
      fontWeight: 400,
      lineHeight: 55,
      fill: "#343B6F",
      align: "left",
    });
    this.textBoldStyle = new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 40,
      fontWeight: 600,
      lineHeight: 55,
      fill: "#343B6F",
      align: "left",
    });

    this.build();
  }

  build() {
    const titleEN = new TranslatableText(app.data["app_title"].en.toUpperCase() + ":", this.textStyle, "en", this.game).getText();
    const titleFR = new TranslatableText(app.data["app_title"].fr.toUpperCase() + " :", this.textStyle, "fr", this.game).getText();

    const subTitleEN = new TranslatableText(this.game.data["app_title"].en.toUpperCase(), this.textBoldStyle, "en", this.game).getText();
    const subTitleFR = new TranslatableText(this.game.data["app_title"].fr.toUpperCase(), this.textBoldStyle, "fr", this.game).getText();
    subTitleEN.position.set(0, 57);
    subTitleFR.position.set(0, 57);

    this.addChild(titleEN);
    this.addChild(titleFR);
    this.addChild(subTitleEN);
    this.addChild(subTitleFR);

    this.reset();
  }

  buildAnimations() {
    // No animation for now
  }
}
